import { useRecoilValue } from "recoil";
import { WindowResizeState } from "../store/states/WindowResizeState";

export const useWindowSize = () => {
  const windowResize = useRecoilValue(WindowResizeState);

  return { isMobile: windowResize.isMobile };
};
